<template>
  <pict
    class="join-organisation-image__image"
    block-name="join-organisation-image"
    :modifiers="['rendering-pixelated']"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageLEN from "./images/joined-organisation.png"
import imageL2xEN from "./images/joined-organisation@2x.png"
import imageLDE from "./images/joined-organisation.png"
import imageL2xDE from "./images/joined-organisation@2x.png"

export default {
  name: "JoinOrganisationImage",
  components: {
    Pict
  },
  computed: {
    useDEImages() {
      return this.$i18n.locale === "de"
    },
    imageProps() {
      return {
        default: {
          src: this.useDEImages ? imageLDE : imageLEN,
          srcset: {
            "2x": this.useDEImages ? imageL2xDE : imageL2xEN
          }
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Illustration of three people on a light yellow half-circle background. One on the left is wearing a yellow long-sleeved shirt, dark pants, and blue shoes. The middle person is wearing a dark blue top, yellow pants and blue shoes, the one on the right wears a yellow top, blue striped pants and dark blue shoes. The left and middle person hold a banner that says “Welcome” in capital letters. The middle and right person also hold three balloons each, in dark blue, blue, and yellow. The right person is also holding a stack of books"
      },
      de: {
        alt: 'Illustration von drei Personen, die alle Kleidung in Blau- und Gelbtönen tragen.  Die linke und die mittlere Person halten ein Banner, auf dem in Großbuchstaben "Welcome" steht. Die mittlere und die rechte Person halten außerdem jeweils drei Luftballons. Die rechte Person balanciert darüber hinaus einen Stapel Bücher in der Hand'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.join-organisation-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
